import { Controller } from "@hotwired/stimulus"

// A small confirmation that opens in place, for actions that destroy one
// thing rather than a whole record. Escape and an outside click both cancel,
// and focus returns to the trigger.
//
// An optional row target is hidden while the panel is open, so the
// confirmation takes over the space it is confirming instead of covering it.
export default class extends Controller {
  static targets = ["panel", "trigger", "row"]

  connect() {
    this.closeOnOutside = this.#closeOnOutside.bind(this)
    this.closeOnEscape = this.#closeOnEscape.bind(this)
  }

  disconnect() {
    this.#stopListening()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    if (this.hasRowTarget) this.rowTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    // Keep/Cancel is the first control. Move focus before the hidden form's
    // trigger drops out of the keyboard order; never focus the destructive action.
    this.panelTarget.querySelector('a[href], button:not([disabled])')?.focus()
    document.addEventListener("click", this.closeOnOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    if (this.hasRowTarget) this.rowTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.#stopListening()
    this.triggerTarget.focus()
  }

  #stopListening() {
    document.removeEventListener("click", this.closeOnOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  #closeOnOutside(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  #closeOnEscape(event) {
    if (event.key !== "Escape") return
    this.close()
  }
}
